import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { MdwDatePickerHeader } from '../date-picker-header/date-picker-header';

@Component({
  selector: 'mdw-calendar',
  templateUrl: './calendar.html',
  styleUrls: ['./calendar.scss'],
  imports: [MatDatepickerModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class.size-small]': "size() === 'small'",
  },
})
export class MdwCalendar {
  public value = model<Date | null>(null);
  public startAt = input<Date | null>(null);
  public filterType = input<'future' | 'past' | 'none'>('none');
  public size = input<'small' | 'medium'>('medium');

  protected readonly header = MdwDatePickerHeader;

  protected dateFilter = (d: Date | null): boolean => {
    if (!d) {
      return false;
    }

    const filterStrategy = this.filterType();
    if (!filterStrategy || filterStrategy === 'none') {
      return true;
    }

    const todayStart = new Date(new Date().setHours(0, 0, 0, 0));

    if (filterStrategy === 'future') {
      return d < new Date(todayStart.getTime() + 24 * 60 * 60 * 1000);
    }

    return d >= todayStart;
  };

  protected onSelected(value: Date | null): void {
    this.value.set(value);
  }
}
